import React, { FC } from 'react';
import { Card, CardBody, Collapse } from 'react-bootstrap';

type IProps = {
    children?: React.ReactNode;
    isOpen?: boolean;
    className?: string;
};

const Collapsible: FC<IProps> = ({ children, isOpen, className }) => {
    return (
        <Collapse in={isOpen} className={className}>
            <Card className="no-border">
                <CardBody className="no-padding">{children}</CardBody>
            </Card>
        </Collapse>
    );
};

export default Collapsible;
